<template>
  <!-- 问题类型 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="btnList1" ref="btnList">
      <el-button
        v-if="hasPermiss('ycgl_wenTiLeiXin:add')"
        class="itemBtn btnColor"
        @click="addQuestion(1)"
        >新建问题类型</el-button
      >
      <el-button
        v-if="hasPermiss('ycgl_wenTiLeiXin:update')"
        class="itemBtn btnColor"
        @click="addQuestion(0)"
        >修 改</el-button
      >
    </div>
    <!-- 表格 -->
    <el-table
      :max-height="tableHeigth"
      ref="mytable"
      @row-click="rowclick"
      :header-cell-style="{ background: '#f0f0f0' }"
      :data="tableData"
      stripe
      style="width: 100%"
      size="small"
      border
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        fixed="left"
        label="序号"
        align="center"
        type="index"
        width="55"
      ></el-table-column>
      <el-table-column
        fixed="left"
        type="selection"
        align="center"
        width="55"
      ></el-table-column>
      <el-table-column
        prop="title"
        label="问题标题"
        align="center"
        min-width="100"
      ></el-table-column>
      <el-table-column
        prop="comment"
        label="问题备注"
        align="center"
        min-width="100"
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="新建时间"
        align="center"
        min-width="100"
      ></el-table-column>
      <el-table-column
        prop="updateTime"
        label="修改时间"
        align="center"
        min-width="100"
      ></el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <paging
      :pageNum="pageStart"
      :total="pageCount"
      :sizeList="sizeList"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    >
    </paging>
    <!-- 新建异常类型弹窗 -->
    <el-dialog
      title="新建问题类型"
      :visible.sync="isDT"
      width="40%"
      :close-on-click-modal="false"
      center
      :before-close="resetForm"
    >
      <div class="addForm">
        <el-form
          ref="formData"
          size="small"
          :model="formData"
          :rules="formDataRule"
          label-width="80px"
        >
          <el-form-item label="问题标题" prop="title">
            <el-input v-model="formData.title" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="问题备注" prop="comment">
            <el-input
              v-model="formData.comment"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="warning" @click="add" size="mini">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { apiList, Api } from "@/assets/js/api";
import tools from "@/assets/js/tool";
import paging from "@/components/pagings.vue";

export default {
  components: {
    paging,
  },
  name: "questionType",
  data() {
    return {
      tableHeigth: "",
      tableData: [],
      pageStart: 1,
      pageCount: 0,
      pageTotal: 50,
      sizeList: [10, 20, 50, 100, 200],
      isDT: false,
      formData: {
        title: "",
        comment: "",
      },
      formDataRule: {
        title: [{ required: true, message: "请输入", trigger: "blur" }],
      },
      singleData: [],
    };
  },
  created() {
    this.getData();
    this.fetTableHeight();
  },
  methods: {
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },
    getData() {
      //  获取数据
      this.fetTableHeight();
      Api.questionTypePage({
        pageStart: this.pageStart,
        pageTotal: this.pageTotal,
      }).then((res) => {
        if (res.data.status === "success") {
          this.tableData = res.data.result.data;
          this.pageCount = res.data.result.pageCount;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    addQuestion(num) {
      //  新建问题类型
      if (num !== 1) {
        if (this.singleData.length === 1) {
          Api.questionTypeDetail({
            questionTypeId: this.singleData[0].questionTypeId,
          }).then((res) => {
            if (res.data.status === "success") {
              this.formData = res.data.result;
            } else {
              this.$message.error(res.data.message);
            }
          });
        } else {
          this.$message.warning("请选择一条数据");
          return;
        }
      }
      this.isDT = true;
    },
    add() {
      this.$refs["formData"].validate((valid) => {
        if (valid) {
          if (this.formData.questionTypeId) {
            let param = {
              questionTypeId: this.formData.questionTypeId,
              title: this.formData.title,
              comment: this.formData.comment,
            };
            let sign = tools.getSign(param);
            param.sign = sign;
            Api.updateQuestionType(param).then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message);
                this.isDT = false;
                this.getData();
                this.resetForm();
              } else {
                this.$message.error(res.data.message);
              }
            });
          } else {
            let param = {
              title: this.formData.title,
              comment: this.formData.comment,
            };
            let sign = tools.getSign(param);
            param.sign = sign;
            Api.addQuestionType(param).then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message);
                this.isDT = false;
                this.getData();
                this.resetForm();
              } else {
                this.$message.error(res.data.message);
              }
            });
          }
        }
      });
    },

    resetForm() {
      this.$refs["formData"].resetFields();
      this.isDT = false;
      this.formData = {
        title: "",
        comment: "",
      };
    },
    handleSelectionChange(e) {
      this.singleData = e;
    },
    handleSizeChange(val) {
      this.pageTotal = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pageStart = val;
      this.getData();
    },
    //    -------- 设置表格高度 ----------
    resetHeight() {
      // 重置table高度
      return new Promise((resolve, reject) => {
        this.tableHeigth = 0;
        resolve();
      });
    },

    fetTableHeight() {
      // 设置table高度
      this.resetHeight().then((res) => {
        this.tableHeigth = this.getHeight();
        this.$nextTick(() => {
          this.$refs.mytable.doLayout();
        });
      });
    },

    getHeight() {
      // 获取表格高度
      let windonHeight = document.body.clientHeight;
      let btnListHeight = this.$refs.btnList.offsetHeight + 16; // 按钮列表  16==上下的margin
      let pagsHeigth = 60; //分页组件
      var otherHeight = btnListHeight + pagsHeigth + 30;
      return Math.floor(windonHeight - otherHeight) || "auto"; //
    },
  },
};
</script>

<style scoped lang="scss">
.addForm {
  width: 100%;

  .el-form-item {
    width: 60%;
    margin: 0 auto;
    margin-bottom: 16px;
  }
}
</style>
